<template>
  <div class="select-element">
    <label>{{ title }}</label>
    <div>
      <el-select
        :disabled="disabled"
        :value="value"
        clearable
        class="select-info"
        size="large"
        @input="$emit('input', $event)"
      >
        <el-option
          v-for="option in selects.addressTypes"
          :value="option.value"
          :label="option.label"
          :key="option.value"
          class="select-info"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectMemberAddressType',
  props: ['value', 'title', 'memberId', 'disabled'],
  data() {
    return {
      selects: {
        simple: '',
        addressTypes: [
          {
            key: 'key',
            value: 'value',
          },
        ],
      },
    };
  },
  watch: {
    memberId: {
      handler(newValue, oldValue) {
        this.fetchData();
      },
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.memberId) {
        this.$http
          .get(
            `${process.env.VUE_APP_ANNUAIRE_API_URL}/addresstypesEntities/search/findAddresstypesByPerson?projection=addressTypeDTO&personId=${this.memberId}`,
          )
          .then(response => {
            this.selects.addressTypes = response.data._embedded.addresstypesEntities.map(
              entity => ({
                value: entity.addrtypeId,
                label: entity.addrtypeId,
              }),
            );
          });
      } else {
        this.selects.addressTypes = [];
      }
    },
  },
};
</script>

<style>
.form-group2 {
  margin-bottom: 10px;
}
.el-select .el-input.is-disabled .el-input__inner {
  cursor: not-allowed;
  color: #66615b;
  background-color: lightgray;
  border: #66615b;
}
.select-element {
  padding-left: 30px;
}
</style>
